import axios from "utils/axios";

const GET_MEMBERINFO_ROUTE = `${process.env.REACT_APP_API_DOMAIN}/api/v1/membership/member-info`;

export const getMemberInfoRequest = (data) =>
  axios.post(`${GET_MEMBERINFO_ROUTE}`, data, {
    headers: { "Content-Type": "application/json" },
  });
